"use client";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useCallback, useRef } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import FocusLock from "react-focus-lock";
import { Box, Text, Fade, useMultiStyleConfig, IconButton, forwardRef, useBreakpointValue, useOutsideClick, Flex, } from "@chakra-ui/react";
import { Icons } from "../../../assets/icons";
import { ButtonVariant, SvgSpriteConsumer } from "../../atoms";
import { DrawerVariant } from "../Drawer/Drawer.types";
const InnerDrawer = forwardRef(({ children, isOpen, title, icon, onClose, variant = DrawerVariant.DEFAULT, }, ref) => {
    const display = useBreakpointValue({
        sm: "mobile",
        md: "tablet",
        lg: "desktop",
    }, {
        fallback: "lg",
    });
    const styles = useMultiStyleConfig("InnerDrawer", {
        display,
        title,
        icon,
        variant,
    });
    const initialFocusRef = useRef(null);
    const dialogRef = useRef(null);
    const handleClose = useCallback((event) => {
        event.stopPropagation();
        onClose(event);
    }, [onClose]);
    useEffect(() => {
        const onKeyPress = (e) => {
            if (e.key === "Escape") {
                handleClose(e);
            }
        };
        if (isOpen) {
            window.addEventListener("keyup", onKeyPress);
        }
        return () => {
            window.removeEventListener("keyup", onKeyPress);
        };
    }, [isOpen, handleClose]);
    useOutsideClick({
        ref: dialogRef,
        handler: (event) => {
            if (isOpen) {
                handleClose(event);
            }
        },
    });
    return (_jsxs(Box, Object.assign({ ref: ref, sx: styles.drawerContainer, "aria-hidden": !isOpen, pointerEvents: isOpen ? "auto" : "none" }, { children: [_jsx(Fade, { in: isOpen, style: styles.backdrop, onClick: handleClose }), _jsx(FocusLock, Object.assign({ autoFocus: true, returnFocus: true, disabled: true, persistentFocus: false }, { children: _jsx(Box, Object.assign({ ref: dialogRef, role: "dialog", sx: styles.slide, transform: isOpen ? "translateX(0%)" : "translateX(100%)" }, { children: _jsxs(Box, Object.assign({ sx: styles.drawer }, { children: [variant === DrawerVariant.DEFAULT && (_jsxs(_Fragment, { children: [_jsx(Box, Object.assign({ sx: styles.closeButtonContainer }, { children: _jsx(IconButton, { "aria-label": "Close", variant: ButtonVariant.ICON, icon: _jsx(SvgSpriteConsumer, { svgId: Icons.DELETE24, size: 24 }), onClick: handleClose, ref: initialFocusRef, sx: styles.closeButton }) })), _jsxs(Box, Object.assign({ sx: styles.titleContainer }, { children: [icon && (_jsx(Box, Object.assign({ sx: styles.icon }, { children: _jsx(SvgSpriteConsumer, { svgId: icon.svgId, size: 24 }) }))), _jsx(Text, Object.assign({ sx: styles.title }, { children: title.text }))] }))] })), variant === DrawerVariant.SIDE_PANEL && (_jsxs(Flex, Object.assign({ sx: styles.titleContainer }, { children: [_jsx(Text, Object.assign({ sx: styles.title }, { children: title.text })), _jsx(IconButton, { "aria-label": "Close", variant: ButtonVariant.ICON, icon: _jsx(SvgSpriteConsumer, { svgId: Icons.DELETE24, size: 24 }), onClick: handleClose, ref: initialFocusRef, sx: styles.closeButton })] }))), children] })) })) }))] })));
});
InnerDrawer.displayName = "InnerDrawer";
export default InnerDrawer;
//# sourceMappingURL=InnerDrawer.js.map